/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenExportsCtrl", [
		"$scope", "toastr", "Utils", "$uibModal", "OpenExportsService", "AdminClientsService", "AdminConsumersService", "AdminExportTemplatesService", "$controller", "$timeout", "ENV", "$location", "$window",
		function ($scope, toastr, Utils, $uibModal, OpenExportsService, AdminClientsService, AdminConsumersService, AdminExportTemplatesService, $controller, $timeout, ENV, $location, $window) {

		$controller("OpenExportsCtrlParent", {$scope: $scope});

		$scope.data = {
			exports: {},
			referential: {},
			gtfsExportsNb: 0,
			simulationExportSuffix: "",
			hasOpendatasoftConsumers: false,
			exportButtonDisabled: false,
			exportLaunched: false,
			scheduleNetexFaresExport: false,
			scheduleNetexFaresExportDate: null,
			nextScheduledNetexFaresExportDate: null,
		};

		AdminClientsService.getReferentialIdAndUser().then(
			(referential) => {
				OpenExportsService.getNextScheduledNetexFaresExportDate(referential.id).then((response) => {
					$scope.data.nextScheduledNetexFaresExportDate = response.data.when;
			});
		});

		$scope.filterSpecialChars = function (input) {
			const regex = /[^A-Za-z0-9]/ig;
			$scope.data.simulationExportSuffix = $scope.data.simulationExportSuffix.replaceAll(regex, '');
		};

		$scope.isSimulation = function () {
			const ref =  window.sessionStorage.getItem("referential");
			if (ref != null) {
				return ref.startsWith("simulation_");
			} else {
				return false;
			}
		};

		AdminExportTemplatesService.getAll().then((response) => {
			const data = response.data;
			if (data !== undefined ){
				for (const currExport of data) {
					if (currExport.exportEnabled === false){
						continue;
					}

					if (currExport.consumers != undefined){
						for (const currConsumer of currExport.consumers) {
							if (currConsumer.type === "OPENDATASOFT"){
								$scope.data.hasOpendatasoftConsumers = true;
							}
						}
					}
				}
			}
		});


		let timeoutGTFSExportData,
			timeoutNeptuneExportData,
			timeoutNetexExportData,
			timeoutPoiExportData,
			timeoutStopPlaceExportData,
			timeoutParkingExportData,
			timeoutNetexFaresExportData,
			maxGTFSResults = 20,
			maxNeptuneResults= 20,
			maxNetexResults = 20,
			maxNbResults = 9,
			maxNetexFaresResults = 20,
			refId;
		$scope.activeTab = [0,0];


		let getGTFSExportData = function () {
				OpenExportsService.getExportsByType(refId,'gtfs',maxGTFSResults)
					.then((response) => {
						const data = response.data;
						if (data !== null && data !== undefined){
							let resultList = data.filter(exp => isExportInEvents(exp.events,'gtfs'));
							$scope.data.gtfsExportsNb = resultList.length;
							$scope.data.gtfsExports = resultList;
						}
						timeoutGTFSExportData = $timeout(() => getGTFSExportData(), 5000);
					})
					.catch(() => {
						toastr.error("Problème lors de la récupération des exports GTFS");
						timeoutGTFSExportData = $timeout(() => getGTFSExportData(), 5000);
					});
		};

		let getSimulationGTFSExportData = function () {
			OpenExportsService.getExportsByType(refId,'gtfs',maxGTFSResults)
				.then((response) => {
					const data = response.data;
					if (data !== null && data !== undefined){
						let resultList = data.filter(exp => isSimulationExportsInEvents(exp.events,'gtfs'));
						$scope.data.gtfsExportsNb = resultList.length;
						$scope.data.gtfsExports = resultList;
					}
					timeoutGTFSExportData = $timeout(() => getSimulationGTFSExportData(), 5000);
				})
				.catch(function () {
					toastr.error("Problème lors de la récupération des exports GTFS");
					timeoutGTFSExportData = $timeout(() => getSimulationGTFSExportData(), 5000);
				});
		};

		let getNeptuneExportData = function () {
			OpenExportsService.getExportsByType(refId,'neptune',maxNeptuneResults)
				.then((response) => {
					const data = response.data;
					if (data !== null && data !== undefined){
						let resultList = data.filter(exp => isExportInEvents(exp.events,'neptune'));
						$scope.data.neptuneExportsNb = resultList.length;
						$scope.data.neptuneExports = resultList;
					}
					timeoutNeptuneExportData = $timeout(() => getNeptuneExportData(), 5000);
				})
				.catch(function () {
					toastr.error("Problème lors de la récupération des exports neptune");
					timeoutNeptuneExportData = $timeout(() => getNeptuneExportData(), 5000);
				});
		};

		let getSimulationNeptuneExportData = function () {
			OpenExportsService.getExportsByType(refId,'neptune',maxNeptuneResults)
				.then((response) => {
					const data = response.data;
					if (data !== null && data !== undefined){
						let resultList = data.filter(exp => isSimulationExportsInEvents(exp.events,'neptune'));
						$scope.data.neptuneExportsNb = resultList.length;
						$scope.data.neptuneExports = resultList;
					}
					timeoutNeptuneExportData = $timeout(() => getSimulationNeptuneExportData(), 5000);
				})
				.catch(() => {
					toastr.error("Problème lors de la récupération des exports neptune");
					timeoutNeptuneExportData = $timeout(() => getSimulationNeptuneExportData(), 5000);
				});
		};

		let getNetexExportData = function () {
			OpenExportsService.getExportsByType(refId,'netex',maxNetexResults).then((response) =>  {
				const data = response.data;
					if (data !== null && data !== undefined){
						let resultList = data.filter(exp => isExportInEvents(exp.events,'netex'));
						$scope.data.netexExportsNb = resultList.length;
						$scope.data.netexExports = resultList;
					}
					timeoutNetexExportData = $timeout(() => getNetexExportData(), 5000);
				})
				.catch(() => {
					toastr.error("Problème lors de la récupération des exports netex");
					timeoutNetexExportData = $timeout(() => getNetexExportData(), 5000);
				});
		};

		let getSimulationNetexExportData = function () {
			OpenExportsService.getExportsByType(refId,'netex',maxNetexResults).then((response) => {
				const data = response.data;
				if (data !== null && data !== undefined){
					let resultList = data.filter(exp => isSimulationExportsInEvents(exp.events,'netex'));
					$scope.data.netexExportsNb = resultList.length;
					$scope.data.netexExports = resultList;
				}
				timeoutNetexExportData = $timeout(() => getSimulationNetexExportData(), 5000);
				})
				.catch(() => {
					toastr.error("Problème lors de la récupération des exports netex");
					timeoutNetexExportData = $timeout(() => getSimulationNetexExportData(), 5000);
				});
		};

		if ($scope.isSimulation()) {
			AdminClientsService.getReferentialIdFromSimulation().then((data) => {
				refId = data;
				$scope.data.referential = window.sessionStorage.getItem("referential");
				getSimulationGTFSExportData();
				getSimulationNeptuneExportData();
				getSimulationNetexExportData();
			});
		} else {
			AdminClientsService.getReferentialId().then((data) => {
				refId = data;
				$scope.data.referential = window.sessionStorage.getItem("referential");
				getGTFSExportData();
				getNeptuneExportData();
				getNetexExportData();
			});
		};

		let getStopPlaceFileList  = function () {
			AdminClientsService.getAllClients(false).then((clients) => {
					const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
					if (client == null || client === undefined){
						return;
					}

					OpenExportsService.getStopPlaceFileList(client.code, maxNbResults).then((response) => {
							$scope.stopPlaceExportList = response.data;
							timeoutStopPlaceExportData = $timeout(() => getStopPlaceFileList(), 30000);
						}).catch(() => {
						toastr.error("Problème lors de la récupération de la liste des fichiers NeTex");
					});
				});
		};

		getStopPlaceFileList();

		let getPOIFileList  = function () {

			AdminClientsService.getAllClients(false).then((clients) => {
				const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
				if (client == null || client === undefined){
					return;
				}

				OpenExportsService.getPOIFileList(client.code,maxNbResults).then((response) => {
					$scope.poiFileList = response.data;
					timeoutPoiExportData = $timeout(() => getPOIFileList(), 30000);
				})
			  	.catch(() => toastr.error("Problème lors de la récupération de la liste des fichiers NeTex"));
			});
		};

		getPOIFileList();

		let getParkingsFileList = function () {
			AdminClientsService.getAllClients(false).then((clients) => {
				const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
				if (client == null || client === undefined){
					return;
				}
				OpenExportsService.getParkingsFileList(client.code, maxNbResults).then((response) => {
					$scope.parkingsFileList = response.data;
					timeoutParkingExportData = $timeout(() => getParkingsFileList(), 30000);
				})
			  	.catch(() => toastr.error("Problème lors de la récupération de la liste des fichiers NeTex Parking"));
			});
		};

		getParkingsFileList();

		let getNetexFaresList = function () {
			OpenExportsService.getAllFareExports(maxNetexFaresResults)
				.then(response => {
					$scope.data.netexFareExports = response.data;
					timeoutNetexFaresExportData = $timeout(() => getNetexFaresList(), 5000);
				})
				.catch(() => {
					toastr.error("Impossible de récupérer les exports NeTeX tarifaire");
					timeoutNetexFaresExportData = $timeout(() => getNetexFaresList(), 5000);
				});
		};

		if ($window._env_.IS_FARES_ACTIVATED === "true") {
			getNetexFaresList();
		}

		$scope.loadMoreNetexFares = function () {
			maxNetexFaresResults = 9000;
			getNetexFaresList();
		};

		$scope.loadMoreStopPlaces = function () {
			maxNbResults = 0;
			getStopPlaceFileList();
		};

		var manualExportLaunchModal;
		$scope.openManualExportPopup = function () {
			manualExportLaunchModal = Utils.openModal($uibModal, "manualExportLaunch.html", $scope);
		};

		var simulationExportModal;
		$scope.openSimulationExportPopup = function () {
			simulationExportModal = Utils.openModal($uibModal, "simulationExportLaunch.html", $scope);
		};

		var opendatasoftModal;
		$scope.openOpendatasoftPopup = function () {
			opendatasoftModal = Utils.openModal($uibModal, "opendatasoftModal.html", $scope);
		};



		$scope.formatCurrentDateToExportFileName = function () {
			let date = new Date();
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString();
			month = month.length > 1 ? month : "0" + month;
			var day = date.getDate().toString();
			day = day.length > 1 ? day : "0" + day;
			var hours = date.getHours().toString();
			hours = hours.length > 1 ? hours : "0" + hours;
			var minutes = date.getMinutes().toString();
			minutes = minutes.length > 1 ? minutes : "0" + minutes;
			var seconds = date.getSeconds().toString();
			seconds = seconds.length > 1 ? seconds : "0" + seconds;
			return year + month + day + hours + minutes + seconds + "Z";
		};

		$scope.getSimulationExportFileName = function () {
			if ($scope.data.simulationExportSuffix.length > 0) {
				return $scope.data.referential + "_" + $scope.formatCurrentDateToExportFileName() + "_" + $scope.data.simulationExportSuffix + ".zip";
			} else {
				return $scope.data.referential + "_" + $scope.formatCurrentDateToExportFileName() + ".zip";
			}
		};

		$scope.loadMoreGtfs = function () {
			maxGTFSResults = 100;
		};

		$scope.loadMoreNeptune = function () {
			maxNeptuneResults = 100;
		};


		$scope.loadMoreNetex = function () {
			maxNetexResults = 100;
		};

		$scope.launchManualExport = function () {

			if (!$scope.canLaunchExport()) {
				return;
			}

			manualExportLaunchModal.close();

			if ($scope.data.exportGeneratedMissingQuays == null) {
				$scope.data.exportGeneratedMissingQuays = false;
			}

			if ($scope.data.exportExternalIds == null) {
				$scope.data.exportExternalIds = false;
			}

			switch ($scope.data.manualExportType) {
				case "NETEX_STOPS":
					$scope.exportStopPlaces();
					break;
				case "NETEX_OFFER":
					$scope.exportNetex();
					break;
				case "GTFS":
					$location.path("/data-management/exports/new/type/gtfs");
					break;
				case "NETEX_PARKINGS":
					$scope.exportParkings();
					break;
				case "NETEX_POI":
					$scope.exportPointOfInterest();
					break;
				case "NETEX_FARES":
					if ($scope.data.scheduleNetexFaresExport) {
						$scope.scheduleNetexFaresExport();
					} else {
						$scope.exportNetexFares();
					}
					break;
				case "NEPTUNE":
					$scope.exportNeptune();
					break;
			}
		};

		$scope.canLaunchExport = function () {
			if ($scope.data.manualExportType !== "NETEX_FARES") {
				return true;
			}
			if (!$scope.data.scheduleNetexFaresExport) {
				return true;
			}
			if (!$scope.data.scheduleNetexFaresExportDate) {
				toastr.error("La date de planification est obligatoire", "Erreur");
				return false;
			}
			if (Date.now() >= $scope.data.scheduleNetexFaresExportDate.getTime()) {
				toastr.error("La date de planification doit être dans le futur", "Erreur");
				return false;
			}
			return true;
		}

		$scope.loadMorePointsOfInterest = function () {
			maxNbResults = 0;
			getPOIFileList();
		};

		$scope.loadMoreParkings = function () {
			maxNbResults = 0;
			getParkingsFileList();
		};

		$scope.scheduleNetexFaresExport = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenExportsService.scheduleNetexFaresExport(referential.id, referential.user, $scope.data.scheduleNetexFaresExportDate)
								  .then(() => toastr.success("", "Export NeTex tarifiaire planifié"))
								  .catch(() => toastr.error("Problème lors de la planification de l'export"));
			});
		};

		$scope.exportNetexFares = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenExportsService.exportFares(referential.id, referential.user)
								  .then(() => toastr.success("", "Export NeTex tarifiaire démarré"))
								  .catch(() => toastr.error("Problème lors de l'export"));
			});
		};

		$scope.exportStopPlaces = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenExportsService.exportStopPlaces(referential.id, referential.user, $scope.data.exportGeneratedMissingQuays, $scope.data.exportExternalIds)
					.then(() => {
						toastr.success("", "Export démarré");
					}).catch(() => {
					toastr.error("Problème lors de l'export");
				});
			});
		};

		$scope.exportParkings = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenExportsService.exportParkings(referential.id, referential.user)
					.then(() => toastr.success("", "Export parkings démarré"))
					.catch(() => toastr.error("Problème lors de l'export"));
			});
		};

		$scope.exportPointOfInterest= function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenExportsService.exportPointOfInterest(referential.id, referential.user)
					.then(() => toastr.success("", "Export POI démarré"))
					.catch(() => toastr.error("Problème lors de l'export"));
			});
		};

		$scope.exportNetex = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
					OpenExportsService.exportNetex(parentRefId, referential.user, $scope.data.exportGeneratedMissingQuays, $scope.data.exportExternalIds)
						.then(() => toastr.success("", "Export démarré"))
						.catch(() => toastr.error("Problème lors de l'export"));
				});
			});
		};

		$scope.exportNeptune = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
					 OpenExportsService.exportNeptune(parentRefId, referential.user)
						 .then(() => toastr.success("", "Export démarré"))
						 .catch(() => toastr.error("Problème lors de l'export"));
				});
			});
		};

		$scope.exportNetexForSimulation = function () {
			simulationExportModal.close();

			AdminClientsService.getReferentielIdAndUserForSimulation().then((ref) => {
				OpenExportsService.exportNetexForSimulation(ref.id, ref.user, $scope.getSimulationExportFileName())
					.then(() => {
						$scope.data.simulationExportSuffix = "";
						toastr.success("", "Export de la simulation démarré");
					}).catch(() => {
						toastr.error("Problème lors de l'export de simulation");
				});
			});
		};

		$scope.exportGtfs = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
					OpenExportsService.exportGtfs(parentRefId, referential.user)
						.then(() => toastr.success("", "Export démarré"))
						.catch(() => toastr.error("Problème lors de l'export"));
				});
			});
		};

		$scope.exportAll = function () {
			$scope.data.exportButtonDisabled = true;

			if ($scope.data.hasOpendatasoftConsumers){
				$scope.openOpendatasoftPopup();
				return;
			}

			$timeout(function() {
				// re-activate export button after 10s
				$scope.data.exportButtonDisabled  = false;
			}, 10000);


			if (!$scope.data.exportLaunched){
				launchPredfinedExports();
			}

		};


		let launchPredfinedExports = function() {
			$scope.data.exportLaunched = true;

			AdminClientsService.getReferentialIdAndUser().then((referential) => {
					OpenExportsService.exportAll(referential.id, referential.user)
						.then(() => {
							toastr.success("", "Exports prédéfinis démarrés");
							$scope.data.exportLaunched = false;
						}).catch(() => {
						toastr.error("Problème lors de l'export global");
						$scope.data.exportLaunched = false;
					});
				});



		};

		$scope.validateOpendatasoftModal = function () {
			opendatasoftModal.close();
			AdminConsumersService.updateOpendatasoftInfos($scope.data.exportDate, $scope.data.description);
			launchPredfinedExports();
		};

		$scope.downloadStopPlacesOrPointsOfInterestFile = function (filePath) {
			AdminClientsService.getAllClients(false).then((clients) => {
				const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
				OpenExportsService.getStopPlaceFile(client.code, filePath)
					.then((response) => {
						let blob = new Blob([response.data], {type: "octet/stream"});
						let a = document.createElement("a");
						a.href = (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = $scope.getFileNameFromPath(filePath);
						document.body.appendChild(a);
						a.click();
					}).catch(() => {
						toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
				});
			});
		};

		$scope.getFileNameFromPath  = function (filePath) {
			let pathArray = filePath.split("/");
			return pathArray[pathArray.length-1];
		};

		$scope.downloadOfferExport = function (jobId) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
					OpenExportsService.getOfferExportFile(parentRefId, jobId)
						.then((response) => {
							let blob = new Blob([response.data], {type: "octet/stream"});
							let a = document.createElement("a");
							a.href = (window.URL || window.webkitURL).createObjectURL(blob);
							a.target = "_blank";
							a.download = response.headers(["rutebankenfilename"]);
							document.body.appendChild(a);
							a.click();
						}).catch(() => {
						toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
					});
				});
			});
		};

		$scope.downloadSimulationExport = function (jobId) {
			AdminClientsService.getReferentialIdFromSimulation().then((parentRefId) => {
				OpenExportsService.getOfferExportFile(parentRefId, jobId)
					.then((response) => {
						let blob = new Blob([response.data], {type: "octet/stream"});
						let a = document.createElement("a");
						a.href = (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = response.headers(["rutebankenfilename"]);
						document.body.appendChild(a);
						a.click();
					}).catch(function (data) {
					toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
				});
			});
		};

		$scope.downloadNetexFaresFile = function (jobId, fileName) {
			OpenExportsService.getNetexFaresExportFile(jobId)
				.then((response) => {
					let blob = new Blob([response.data], {type: "octet/stream"});
					let a = document.createElement("a");
					a.href = (window.URL || window.webkitURL).createObjectURL(blob);
					a.target = "_blank";
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
				})
			 .catch(() => toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement"))
		};

		$scope.$on('$destroy', function (e) {
			if (timeoutGTFSExportData) {
				$timeout.cancel(timeoutGTFSExportData);
			}
			if (timeoutNeptuneExportData) {
				$timeout.cancel(timeoutNeptuneExportData);
			}
			if (timeoutNetexExportData) {
				$timeout.cancel(timeoutNetexExportData);
			}
			if (timeoutPoiExportData) {
				$timeout.cancel(timeoutPoiExportData);
			}
			if (timeoutStopPlaceExportData) {
				$timeout.cancel(timeoutStopPlaceExportData);
			}
			if (timeoutParkingExportData) {
				$timeout.cancel(timeoutParkingExportData);
			}
			if (timeoutNetexFaresExportData) {
				$timeout.cancel(timeoutNetexFaresExportData);
			}
		});

		$scope.isNetexExportExisting  = function () {
			if(!Array.isArray($scope.data.netexExports) || $scope.data.netexExports === undefined || $scope.data.netexExports.length == 0){
				return false;
			}
			return $scope.data.netexExports.find(exp => isExportInEvents(exp.events,'netex'));
		};

		$scope.isNetexSimulationExportExisting  = function () {

			if(!Array.isArray($scope.data.netexExports) || $scope.data.netexExports === undefined || $scope.data.netexExports.length == 0){
				return false;
			}
			return $scope.data.netexExports.find(exp => isSimulationExportsInEvents(exp.events,'netex'));
		};

		$scope.isGtfsSimulationExportExisting = function () {
			if (!Array.isArray($scope.data.exports) || $scope.data.exports === undefined || $scope.data.exports.length == 0){
				return false;
			}
			return $scope.data.exports.find(exp => isSimulationExportsInEvents(exp.events, 'gtfs'));
		};

		$scope.getExportForType  = function (exportType) {


			let dataArray;
			if (exportType === 'neptune'){
				dataArray = $scope.data.neptuneExports;
			}

			if (exportType === 'gtfs'){
				dataArray = $scope.data.gtfsExports;
			}


			if(!Array.isArray(dataArray) || dataArray === undefined || dataArray == 0){
				return;
			}

			let resultList = dataArray.filter(exp => isExportInEvents(exp.events,exportType));
			$scope.data.gtfsExportsNb = resultList.length;
			return resultList;

		};

		$scope.getSimulationExportForType = function (exportType) {
			if(!Array.isArray($scope.data.exports) || $scope.data.exports === undefined || $scope.data.exports.length == 0){
				return;
			}
			return $scope.data.exports.filter(exp => (isSimulationExportsInEvents(exp.events,exportType)));
		};


		let isExportInEvents  = function (events, type) {
			if (type === 'netex'){
				return events.find(event => event.action === 'EXPORT_NETEX' && event.referential != null && !event.referential.startsWith("simulation_"));
			}else
				return events.find(event => event.action === 'EXPORT' && event.type === type && event.referential != null && !event.referential.startsWith("simulation_"));
		};

		let isSimulationExportsInEvents = function (events, type) {
			if (type === 'netex') {
				return events.find(event => event.action === 'EXPORT_NETEX' && event.referential != null && event.referential.startsWith("simulation_"));
			} else {
				return events.find(event => event.action === 'EXPORT' && event.type === type && event.referential != null && event.referential.startsWith("simulation_"));
			}
		};

		$scope.downloadExportFileForJob  = function (job, exportType) {
			let sortedEvents = generateSortedEventArray(job, exportType);
			if ($scope.isSimulation()) {
				return $scope.downloadSimulationExport(sortedEvents[sortedEvents.length - 1].chouetteJobId);
			} else {
				return $scope.downloadOfferExport(sortedEvents[sortedEvents.length - 1].chouetteJobId);
			}
		};

		let reverseFirstEventSorter = function (obj1, obj2) {
			if (obj1.eventtime > obj2.eventtime) return -1;
			if (obj1.eventtime < obj2.eventtime) return 1;
			return 0;
		};

		let generateSortedEventArray = function (job, exportType) {
			let events;

			if (exportType === 'netex'){
				events = job.events.filter(event => event.action === 'EXPORT_NETEX');
			}else{
				events = job.events.filter(event => event.action === 'EXPORT' && event.type === exportType);
			}
			return events.sort(reverseFirstEventSorter);
		};

		$scope.getStatusForExport = function (job, exportType) {
			let state = $scope.getExportState(job, exportType);
			return $scope.getStatusLabel(state);
		};

		$scope.getExportState = function (job, exportType) {
			let sortedEvents = generateSortedEventArray(job, exportType);
			return sortedEvents[sortedEvents.length - 1].state;
		};

		$scope.getExportName = function (job, exportType) {
			let sortedEvents = generateSortedEventArray(job, exportType);
			return sortedEvents[sortedEvents.length - 1].name;
		};

		$scope.generateExportDetailUrl = function(exprt) {
			const event = exprt.events.find(event => event.chouetteJobId);
			if (event) {
				$location.path("/data-management/exports/" + event.referential + "/" + event.chouetteJobId);
			}
		};

		$scope.openSimulationCheckLink = function(){

			window.open(ENV.SIMULATION_CHECK_URL, "_blank");
		};

		$scope.getNetexFaresExportFileByJobId = function(jobId) {
			return OpenExportsService.getNetexFaresExportFile(jobId);
		};

		$scope.getNetexFareStatusLabel = function(status) {
			return OpenExportsService.mapJobStateToExportStatus(status);
		};
	}]);
